import React, { useState } from "react";
import { CharacterHistory } from "../classes/CharacterHistory";
import { RulesContext } from "../contexts/RulesContext";
import ReferenceSheet from "./referenceSheet/ReferenceSheet";
import { Rules } from "../classes/Rules";
import { AlertCenter } from "../classes/AlertCenter";
import { AlertContext } from "../contexts/AlertContext";
import { XPSystem } from "../classes/XPSytem";
import { XPSystemContext } from "../contexts/XPSystemContext";
import { DEFAULT_GAMES } from "../constants/constants";
import { RpgActions } from "../classes/RpgActions";
import { CharacterHistoryContext } from "../contexts/CharacterHistoryContext";
import CharacterBonusesView from "./CharacterBonusesView";

interface Props {
  game: string;
  alertCenter: AlertCenter;
}

export default ({ game, alertCenter }: Props) => {
  const [, updateState] = React.useState<object>();
  const triggerRender = React.useCallback(() => updateState({}), []);
  const [rpgActions] = useState(() => new RpgActions());
  const [rules] = useState<Rules>(
    () =>
      new Rules(
        triggerRender,
        DEFAULT_GAMES[game],
        rpgActions.addActionsOrReset,
        alertCenter.addModuleAlert,
        alertCenter.addItemAlert
      )
  );
  const [xpSystem] = useState<XPSystem>(
    () =>
      new XPSystem(
        DEFAULT_GAMES[game],
        rules.addKeyCallback,
        rules.checkKeyDuplicateCallback
      )
  );
  const [characterHistories] = useState<CharacterHistory[]>(() => [
    new CharacterHistory(
      triggerRender,
      rules,
      rpgActions.addActionsOrReset,
      alertCenter.addItemAlert
    ),
  ]);

  const characterSheets = characterHistories.map(
    (characterHistory: CharacterHistory, index: number) => {
      return (
        <CharacterHistoryContext.Provider
          value={characterHistory}
          key={`character-${index}`}
        >
          <CharacterBonusesView />
        </CharacterHistoryContext.Provider>
      );
    }
  );

  return (
    <AlertContext.Provider value={alertCenter}>
      <RulesContext.Provider value={rules}>
        <XPSystemContext.Provider value={xpSystem}>
          {characterSheets}
          <ReferenceSheet />
        </XPSystemContext.Provider>
      </RulesContext.Provider>
    </AlertContext.Provider>
  );
};
